import "./index.scss";
import { Modal } from "components/UI/molecules";
import { useState } from "react";

export const BrandsAreaHeader = () => {
  const [isPopOverOpen, setPopOver] = useState(false);

  return (
    <div className="brands-area-header">
      <h1>Buy Gift Cards - Save Instantly</h1>
      <button className="info-icon" onClick={() => setPopOver(true)}>
        &#8505;
      </button>
      <Modal
        customClassName="brands-area-modal"
        isOpen={isPopOverOpen}
        onBackdropClick={() => setPopOver(false)}
        header={
          <>
            <h3>Buy gift cards on Raise</h3>
            <button onClick={() => setPopOver(false)}>&#x2716;</button>
          </>
        }
      >
        <p>
          The Raise marketplace makes it easy to buy gift cards online at a
          discount so you can save on a wide variety of brands, retailers, and
          restaurants. Search by brand name, highest discount, price, category,
          or card type to find the gift card that best suits your budget and
          your lifestyle.
        </p>
        <p>
          Whether you shop at retail stores like{" "}
          <a href="/buy-the-home-depot-gift-cards">Home Depot</a>,{" "}
          <a href="/buy-macy-s-gift-cards">{"Macy's"}</a>,{" "}
          <a href="/buy-walmart-gift-cards">Walmart</a>, and{" "}
          <a href="/buy-target-gift-cards">Target</a> or the ever popular{" "}
          <a href="/buy-starbucks-coffee-gift-cards">Starbucks</a> and{" "}
          <a href="/buy-whole-foods-market-physical-gift-cards">Whole Foods</a>,
          you'll come across hundreds of discount gift cards to choose from on
          Raise. As we are a marketplace, gift card brands and discounts will
          vary at any point in time, with current prices averaging 21.6% off.
        </p>
        <p>
          Our gift card marketplace offers physical cards, electronic cards and
          printable vouchers, so you can shop online or in stores. Plus, we
          provide free shipping on all orders to make the deal even sweeter. We
          want you to feel confident when buying gift cards online at a
          discount. All cards are covered by our 90 Day Money-Back Guarantee.
        </p>
      </Modal>
    </div>
  );
};
